var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-button",
    {
      directives: [
        {
          name: "clipboard",
          rawName: "v-clipboard:copy",
          value: _vm.text,
          expression: "text",
          arg: "copy",
        },
        {
          name: "clipboard",
          rawName: "v-clipboard:success",
          value: _vm.onCopySuccess,
          expression: "onCopySuccess",
          arg: "success",
        },
        {
          name: "clipboard",
          rawName: "v-clipboard:error",
          value: _vm.onCopyError,
          expression: "onCopyError",
          arg: "error",
        },
      ],
      attrs: { size: _vm.size, type: _vm.type },
    },
    [
      _c("a-icon", { attrs: { type: "copy" } }),
      _vm.showText ? _c("span", [_vm._v(_vm._s(_vm.buttonText))]) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }